import { Box, Button, TextField } from "@mui/material";
import React, { useState } from "react";
import { useUser } from "../../contexts/UserContext";
import { useTranslation } from "react-i18next";
import { CardContainer, SubContainer, SubTitle  } from "./styles";
import Translator from "../i18nComponents/Translator";

export default function TraderCard() {
  const { handleSaveOptions } = useUser();

  const [emailIq, setEmailIq] = useState(null);
  const [passIq, setPassIq] = useState(null);
  const [tokenDemo, setTokenDemo] = useState(null);
  const [tokenReal, settokenReal] = useState(null);
  const [emailCapital, setEmailCapital] = useState(null);
  const [passCapital, setPassCapital] = useState(null);
  //
  const [emailQuotex, setEmailQuotex] = useState(null);
  const [passQuotex, setPassQuotex] = useState(null);
  //
  const [emailProcket, setEmailProcket] = useState(null);
  const [passProcket, setPassProcket] = useState(null);
  const [emailAvalon, setEmailAvalon] = useState(null);
  const [passAvalon, setPassAvalon] = useState(null);
  const [emailExnova, setEmailExnova] = useState(null);
  const [passExnova, setPassExnova] = useState(null);
  const [emailBinomo, setEmailBinomo] = useState(null);
  const [passBinomo, setPassBinomo] = useState(null);
  //const [emailBitness, setEmailBitness] = useState(null);
  //const [passBitness, setPassBitness] = useState(null);
  const [emailBinolla, setEmailBinolla] = useState(null);
  const [passBinolla, setPassBinolla] = useState(null);
  const [emailOlimp, setEmailOlimp] = useState(null);
  const [passOlimp, setPassOlimp] = useState(null);
  const [emailDayprofit, setEmailDayprofit] = useState(null);
  const [passDayprofit, setPassDayprofit] = useState(null);
   //
  const [emailBullex, setEmailBullex] = useState(null);
  const [passBullex, setPassBullex] = useState(null);
  //
  const [emailOptinary, setEmailOptinary] = useState(null);
  const [passOptinary, setPassOptinary] = useState(null);
  //
  const [emailBroker10, setEmailBroker10] = useState(null);
  const [passBroker10, setPassBroker10] = useState(null);
  //
  const [emailPixtrade, setEmailPixtrade] = useState(null);
  const [passPixtrade, setPassPixtrade] = useState(null);
  //
  const [emailOptgo, setEmailOptgo] = useState(null);
  const [passOptgo, setPassOptgo] = useState(null);
  //
  const [emailPolarium, setEmailPolarium] = useState(null);
  const [passPolarium, setPassPolarium] = useState(null);
  //
  const [emailCasaTrade, setEmailCasaTrade] = useState(null);
  const [passCasaTrade, setPassCasaTrade] = useState(null);
  //
  const [emailAntriunBr, setEmailAntriunBr] = useState(null);
  const [passAntriunBr, setPassAntriunBr] = useState(null);
  //
  const [emailMango, setEmailMango] = useState(null);
  const [passMango, setPassMango] = useState(null);
  //
  const [emailHomeBroker, setEmailHomeBroker] = useState(null);
  const [passHomeBroker, setPassHomeBroker] = useState(null);
  //

  //const [emailQuotexGoo, setEmailQuotexGoo] = useState(null);
  //const [passQuotexGoo, setPassQuotexGoo] = useState(null);
  //
  //const [emailBinollaGoo, setEmailBinollaGoo] = useState(null);
  //const [passBinollaGoo, setPassBinollaGoo] = useState(null);
  //
  //const [emailIQGoo, setEmailIQGoo] = useState(null);
  //const [passIQGoo, setPassIQGoo] = useState(null);

  //const [quotexToken, setQuotexToken] = useState(null);
  //const [pocketToken, setPocketToken] = useState(null);
  //
  //const [binomoToken, setBinomoToken] = useState(null);
  //const [binomoDevice, setBinomoDevice] = useState(null);
  //const [stockityToken, setStockityToken] = useState(null);
  //const [stockityDevice, setStockityDevice] = useState(null);
  //

  const {t} = useTranslation()

  return (
    <SubContainer>

      <CardContainer>
        <SubTitle>IQ option</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailIq(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={t("senha")}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setPassIq(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailIq,
              password: passIq,
              key: "IQOption",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Quotex</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailQuotex(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassQuotex(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailQuotex,
              password: passQuotex,
              key: "Quotex",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Pocket Option</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailProcket(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassProcket(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailProcket,
              password: passProcket,
              key: "Pocket",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Exnova</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailExnova(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassExnova(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailExnova,
              password: passExnova,
              key: "Exnova",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Deriv</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Token Demo"}
            type="text"
            onChange={(e) => setTokenDemo(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            label={"Token Real"}
            onChange={(e) => settokenReal(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              tokenDemo,
              tokenReal,
              key: "binarydata",
            })
          }
          variant="contained"
        >
         <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Binolla</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailBinolla(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassBinolla(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailBinolla,
              password: passBinolla,
              key: "Binolla",
            })
          }
          variant="contained"
        >
         <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Binomo</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailBinomo(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassBinomo(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailBinomo,
              password: passBinomo,
              key: "Binomo",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>OlympTrade</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailOlimp(e.target.value)}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassOlimp(e.target.value)}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailOlimp,
              password: passOlimp,
              key: "Olymp",
            })
          }
          variant="contained"
        >
         <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Bullex</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailBullex(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassBullex(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailBullex,
              password: passBullex,
              key: "Bullex",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Capital Bear</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailCapital(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassCapital(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailCapital,
              password: passCapital,
              key: "CapitalBear",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>DayProfit</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailDayprofit(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassDayprofit(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailDayprofit,
              password: passDayprofit,
              key: "DayProfit",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Broker10</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailBroker10(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassBroker10(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailBroker10,
              password: passBroker10,
              key: "Broker10",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Pixtrade</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailPixtrade(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassPixtrade(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailPixtrade,
              password: passPixtrade,
              key: "Pixtrade",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Polarium</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailPolarium(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassPolarium(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailPolarium,
              password: passPolarium,
              key: "Polarium",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>HomeBroker</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailHomeBroker(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassHomeBroker(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailHomeBroker,
              password: passHomeBroker,
              key: "HomeBroker",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Avalon</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailAvalon(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassAvalon(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailAvalon,
              password: passAvalon,
              key: "Avalon",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>CasaTrader</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailCasaTrade(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassCasaTrade(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailCasaTrade,
              password: passCasaTrade,
              key: "CasaTrade",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>AtriunBroker</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailAntriunBr(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassAntriunBr(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailAntriunBr,
              password: passAntriunBr,
              key: "AtriunBroker",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Mango</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailMango(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassMango(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailMango,
              password: passMango,
              key: "Mango",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Optgo</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailOptgo(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassOptgo(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailOptgo,
              password: passOptgo,
              key: "Optgo",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Optinary</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailOptinary(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassOptinary(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailOptinary,
              password: passOptinary,
              key: "Optinary",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

    </SubContainer>

  );
}

/*
CODIGO EXCLUIDO

<CardContainer>
        <SubTitle>Binomo Token</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Token"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setBinomoToken(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={"DeviceID"}
            onChange={(e) => setBinomoDevice(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: binomoToken,
              password: binomoDevice,
              key: "binomotoken",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Stockity Token</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Token"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setStockityToken(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={"DeviceID"}
            onChange={(e) => setStockityDevice(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: stockityToken,
              password: stockityDevice,
              key: "stockitytoken",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>
      
<CardContainer>
        <SubTitle>Pocket Token</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            value={pocketToken}
            label={"Token"}
            onChange={(e) => setPocketToken(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              token: pocketToken,
              key: "pockettoken",
            })
          }
          variant="contained"
        >
          Salvar
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>Quotex Google</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailQuotexGoo(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassQuotexGoo(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailQuotexGoo,
              password: passQuotexGoo,
              key: "quotexgoo",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>


      <CardContainer>
        <SubTitle>Binolla Google</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailBinollaGoo(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassBinollaGoo(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailBinollaGoo,
              password: passBinollaGoo,
              key: "binollagoo",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>

      <CardContainer>
        <SubTitle>IQ Google</SubTitle>
        <Box
          component="form"
          sx={{
            maxWidth: "100%",
          }}
          noValidate
          autoComplete="off"
        >
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            label={"Email"}
            type={"text"}
            autoComplete='off'
            onChange={(e) => setEmailIQGoo(e.target.value.trim())}
            variant="filled"
          />
          <TextField
            fullWidth
            sx={{ marginBottom: "15px" }}
            type={"text"}
            autoComplete='off'
            label={t("senha")}
            onChange={(e) => setPassIQGoo(e.target.value.trim())}
            variant="filled"
          />
        </Box>

        <Button
          onClick={() =>
            handleSaveOptions({
              email: emailIQGoo,
              password: passIQGoo,
              key: "iqgoo",
            })
          }
          variant="contained"
        >
          <Translator path="buttonSalvar"/>
        </Button>
      </CardContainer>
*/
